import { DqlQuery, Query } from '../field';

export class OrderImportError {

  readonly id: Query.OrderField;
  readonly creationTime: Query.OrderField;
  readonly updateTime: Query.OrderField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.OrderField(prefix + 'id');
    this.creationTime = new DqlQuery.OrderField(prefix + 'creation_time');
    this.updateTime = new DqlQuery.OrderField(prefix + 'update_time');
  }

}
